import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import { VALIDATIONS, VALIDATIONS_TEXT } from "../../utils/Validations";
import CustomInput from "../Defaut/CustomInput";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";

const JoinWaitlist = () => {
  const { handleSubmit, control, setValue } = useForm({ mode: "onChange" });
  const [formData, setFormData] = useState({ email: "" });

  const onSubmit = async (data) => {
    try {
      const result = await axios.post(
        `${BASE_URL}user/waitlists`,
        {
          email: data.email,
        },
        {
          headers: {
            token: `d9cbb0a2-87aa-4f20-93d6-5e0bcbe7a59a`,
          },
        }
      );

      const { code, message } = result.data;
      if (code == 200) {
        toast.success("Your mail Succesfully Added in Waitlist");

        setFormData({
          email: "",
        });
        setValue("email", "")
      }
    } catch (e) {
      console.log(e.message);
      toast.error(e.message);
    }
  };
  return (
    <>
      <div className="joinwaitlist-component container" id="about-us">
        <h1>Join the waitlist Today</h1>
        <h5>Sign Up for the waitlist now</h5>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="mt-3 email">
            <Controller
              control={control}
              name="email"
              rules={{
                required: {
                  value: true,
                  message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                },
                maxLength: {
                  value: VALIDATIONS.EMAIL,
                  message: VALIDATIONS_TEXT.EMAIL,
                },
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: VALIDATIONS_TEXT.EMAIL_FORMAT,
                },
              }}
              render={({ field }) => (
                <div className="input-wrapper">
                  <CustomInput
                    {...field}
                    label="Enter Email"
                    placeholder="Enter Email"
                    type="email"
                    className="name"
                    required={true}
                    maxLength={VALIDATIONS.EMAIL}
                    value={field.value}
                    onChange={field.onChange}
                  />
                  <button type="submit" className="email-button">
                    Join Waitlist
                  </button>
                </div>
              )}
            />
          </div>
            <button className="email-button-mobile" onClick={onSubmit}>
            Join Waitlist
          </button>
        </Form>
      </div>
    </>
  );
};
export { JoinWaitlist };
